import { useState } from "react";
import { useOriginalDataObjectExport } from "./useOriginalDataObjectExport";
import OriginalDataObjectFilterList, { OriginalDataObjectFilterObject } from "./OriginalDataObjectFilterList";
import ExportAllLeadsModal from "../../../../../../mogul/modals/ExportAllLeadsModal";
import FilterListButton from "../shared/FilterListButton";

export default function OriginalDataObjectTableHeader({
    typeOfLead,
    title,
    subtitle = '',
    filterLocalStorageKey,
    currentFilter,
    onApplyFilter,
    displayShowAllLeadsToggle = false,
    personSearchFilter = '',
    searchBar,
    onSyncAll,
    unsyncedLeadsCount
}: {
    typeOfLead: 'event_administrator' | 'event_check_in' | 'direct_mail_replies' | 'portal_leads'
    title: string;
    subtitle?: string;
    filterLocalStorageKey: string;
    currentFilter: OriginalDataObjectFilterObject | null;
    onApplyFilter: (filterObject: OriginalDataObjectFilterObject) => void;
    displayShowAllLeadsToggle?: boolean;
    personSearchFilter?: string;
    searchBar?: React.ReactNode;
    onSyncAll?: () => void;
    unsyncedLeadsCount?: number;
}) {

    const [viewingFilter, setViewingFilter] = useState(false)

    const {
        exporting,
        errorExporting,
        onExportLeadListToCSV
    } = useOriginalDataObjectExport(typeOfLead, personSearchFilter)

    return <>
        {/* begin::Header */}
        <div className='card-header align-items-center border-0 mt-3'>
            <div className='d-flex align-items-center w-100'>
                <h3 className='card-title align-items-start flex-column me-auto'>
                    <span className='fw-bolder text-dark fs-3'>
                        {title}
                    </span>
                    {subtitle && <span className='text-gray-400 mt-2 fw-bold fs-6'>{subtitle}</span>}
                </h3>
                {searchBar && (
                    <div className='me-3'>
                        {searchBar}
                    </div>
                )}
                <div className='card-toolbar'>
                {onSyncAll && (unsyncedLeadsCount || 0) > 0 && (
                    <button
                        className='btn btn-sm btn-warning me-2'
                        onClick={onSyncAll}
                    >
                        <span className='d-none d-md-inline'>
                            Sync All ({unsyncedLeadsCount})
                        </span>
                        <span className='d-md-none'>
                            Sync ({unsyncedLeadsCount})
                        </span>
                    </button>
                )}
                <button
                    className='btn btn-sm btn-light me-2'
                    data-bs-toggle='modal'
                    data-bs-target='#modal_export_all_leads'
                >
                    <span className='d-none d-md-inline'>
                        Export
                    </span>
                </button>
                <ExportAllLeadsModal
                    filterChild={<OriginalDataObjectFilterList
                        isFilterChild
                        onReset={() => {
                        }}
                        onCancel={() => { }}
                        currentFilterObject={currentFilter}
                        onApplyFilter={() => { }}
                    />}
                    exporting={exporting}
                    errorExporting={errorExporting}
                    onExport={() => {
                        if (currentFilter) {
                            onExportLeadListToCSV(currentFilter)
                        } else {
                            onExportLeadListToCSV({} as OriginalDataObjectFilterObject) // empty filter for all leads
                        }
                    }}
                    disableExportForReason={(currentFilter?.selectedLocationUniqueIds.length || 0) === 0 ? 'You need to select at least one location to export leads.' : ''}
                />
                <FilterListButton
                    onClick={() => {
                        setViewingFilter(true)
                    }}
                    hasFiltersApplied={
                        (currentFilter?.selectedLocationUniqueIds.length || 0) > 0 ||
                        (currentFilter?.selectedPreneedOptions.length || 0) > 0 ||
                        !!currentFilter?.onlyUnSyncedWith360 ||
                        !!currentFilter?.showAllLeadsEvenIfLocationIsIgnored ||
                        !!currentFilter?.startingUnixTimestamp ||
                        !!currentFilter?.endingUnixTimestamp
                    }
                />
                </div>
            </div>
        </div>
        {/* end::Header */}
        {viewingFilter && <>
            <OriginalDataObjectFilterList
                onReset={() => {
                    onApplyFilter({
                        selectedLocationUniqueIds: [],
                        selectedPreneedOptions: [],
                        onlyUnSyncedWith360: false,
                        showAllLeadsEvenIfLocationIsIgnored: false,
                        startingUnixTimestamp: undefined,
                        endingUnixTimestamp: undefined
                    })
                    localStorage.removeItem(filterLocalStorageKey)
                }}
                onCancel={() => setViewingFilter(false)}
                currentFilterObject={currentFilter}
                onApplyFilter={(filterObject: OriginalDataObjectFilterObject) => {
                    onApplyFilter(filterObject)
                    setViewingFilter(false)
                    localStorage.setItem(filterLocalStorageKey, JSON.stringify(filterObject))
                }}
                displayShowAllLeadsToggle={displayShowAllLeadsToggle}
            />
        </>}
    </>

}